import yup from "./yup";

export const checkoutSchema = yup.object().shape({
    shipmthd:
        yup.string().label('Id de direccion de Envio').max(31)
            .required(),
    observaciones:
        yup.string().label('Observaciones'),
    customerAddresses: yup.array().of(
        yup.object().shape({
            addressCode:
                yup.string().label('addressCode').max(15)
                    .required(),
            addressType:
                yup.string().label('addressType').max(15)
                    .required(),
            address1:
                yup.string().label('Dirección').max(61)
                    .required(),
            address2:
                yup.string().label('Dirección2').max(61),
            address3:
                yup.string().label('Dirección3').max(61),
            city:
                yup.string().label('Ciudad').max(35)
                    .required(),
            state:
                yup.string().label('Provincia').max(29)
                    .required(),
            country:
                yup.string().label('País').max(61)
                    .required(),
            zip:
                yup.string().label('Código postal').max(11)
                    .required(),
            phone1:
                yup.string().label('Tel1').max(21)
                    .required(),
            phone2:
                yup.string().label('Tel2').max(21),
            contactPerson:
                yup.string().label('Persona de Contacto').max(61)
        })
    )
})